import React from 'react';
import ProductCard from './ProductCard';
import { AWNING_FROM_LABEL } from '../../config/startingPrice';
import { STOCK_SHORT } from '../../config/leadTimes';

// Retractable awnings showcase.
//
// Desktop lays the five cards out three on the first row and two centred on
// the second, which keeps each card near the 470px the design was drawn for.
// The grid maths for that lives in HomePage.css.
//
// Mobile is a plain vertical stack: one card per screen, scrolled down to.
// Swiping the images is handled inside the card by the shared Carousel.
export default function AwningsShowcase({ awningProducts }) {
  if (awningProducts.length === 0) return null;

  return (
    <section className="asg-compare" id="awnings">
      <div className="asg-awn-inner">
        <div className="asg-compare-header asg-reveal">
          <p className="asg-section-label">Retractable Awnings - {AWNING_FROM_LABEL} · Free delivery to most of Melbourne · {STOCK_SHORT}</p>
          <h2 className="asg-section-title">Five awnings.<br />One premium build.</h2>
        </div>

        <div className="asg-awn-grid asg-reveal">
          {awningProducts.map((p) => (
            <ProductCard key={p.slug || p._id} product={p} />
          ))}
        </div>
      </div>
    </section>
  );
}
